module.exports = __webpack_public_path__ + "img/img_fps02.b477dd77.jpg";